import { action, observable } from "mobx";
import { ModelBase } from "@shoothill/core";

export class RDDV2ListFilterParamsModel extends ModelBase<RDDV2ListFilterParamsModel, RDDV2ListFilterParamsModelDTO> {
    @observable
    public projectId: string = "";

    @observable
    public searchText: string = "";

    @observable
    public rddV2Id: string | null = null;

    @observable
    public rddV2StatusId: string | null = null;

    fromDto(model: RDDV2ListFilterParamsModelDTO): void {
        this.projectId = model.projectId;
        this.searchText = model.searchText;
        this.rddV2Id = model.rddV2Id;
        this.rddV2StatusId = model.rddV2StatusId;
    }

    toDto(): RDDV2ListFilterParamsModelDTO {
        let dto: RDDV2ListFilterParamsModelDTO = {
            projectId: this.projectId,
            searchText: this.searchText,
            rddV2Id: this.rddV2Id,
            rddV2StatusId: this.rddV2StatusId,
        };
        return dto;
    }

    @action
    public reset = () => {
        this.searchText = "";
        this.rddV2Id = null;
        this.rddV2StatusId = null;
    };
}

export interface RDDV2ListFilterParamsModelDTO {
    projectId: string;
    searchText: string;
    rddV2Id: string | null;
    rddV2StatusId: string | null;
}
